// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"DashboardSectionTitle_titleWrapper__ci2eS","title":"DashboardSectionTitle_title__Qr9fK"};